import { isValidObjectId, randomString } from "./common"
import _ from "lodash"
import { bfs } from "@/utils/algorithm"

// 获取工作流的第一个节点
function getFirstProcess(process) {
  let nextMap = []
  process.forEach(item => {
    nextMap = nextMap.concat(item.nexts)
  })
  nextMap = new Set(nextMap)
  return process.find(item => !nextMap.has(item.id))
}

// 通过id在流程中获取节点的信息
function getNodeInProcess(id, process) {
  return process.find(i => i.id == id)
}

// 递归遍历请求的工作流数据
function getStructure(head, process) {
  let processStructure = []
  while (head) {
    if (head.type == "Gateway") {
      if (head.id.indexOf("_close") != -1) return processStructure
      head.children = head.nexts.map(item => getStructure(getNodeInProcess(item, process), process))
      processStructure.push(head)
      let close = getNodeInProcess(head.id + "_close", process)
      if (!close || !close.nexts[0]) return processStructure
      head = getNodeInProcess(close.nexts[0], process)
    } else {
      processStructure.push(head)
      if (!head.nexts[0]) return processStructure
      head = getNodeInProcess(head.nexts[0], process)
    }
  }
  return processStructure
}

// 将请求的工作流数据传换成用于视图遍历的数据
export function transferProcessStructure(process) {
  if (_.isEmpty(process)) return []
  process = _.cloneDeep(process)
  return getStructure(getFirstProcess(process), process)
}

// 各不同节点的设置drawer的setting
const settingMap = {
  workFlowStart: {
    START_TYPE_DATA: {
      setting: ["selectSheet", "trigger", "triggerCondition", "parallel", "dataSources"],
      style: {
        nameBg: "bg-yellow-trigger",
        nameIcon: "workflow_trigger_sheet"
      }
    },
    START_TYPE_TIME: {
      setting: ["selectSheet", "selectTimeField", "selectExecuteTime", "triggerCondition"],
      style: {
        nameBg: "bg-blue-trigger",
        nameIcon: "workflow_trigger_time"
      }
    },
    START_TYPE_CRON: {
      setting: ["inputCornstr"],
      style: {
        nameBg: "bg-blue-trigger",
        nameIcon: "workflow_trigger_cron"
      }
    },
    START_TYPE_BTN: {
      setting: ["btnTrigger", "parallel"],
      style: {
        nameBg: "bg-yellow-trigger",
        nameIcon: "workflow_trigger_button"
      }
    },
    START_TYPE_TASK: {
      setting: ["taskTrigger", "topTip"],
      style: {
        nameBg: "bg-yellow-trigger",
        nameIcon: "workflow_trigger_task"
      }
    },
    START_TYPE_SUB: {
      setting: ["dataSource", "workFlowTrigger", "params", "extraInput"],
      style: {
        nameBg: "bg-blue-trigger",
        nameIcon: "workflow_trigger_sub-process"
      }
    },
    START_TYPE_VALIDATE: {
      setting: ["validateTrigger", "triggerCondition"],
      style: {
        nameBg: "bg-blue-trigger",
        nameIcon: "workflow_trigger_validate"
      }
    },
    START_TYPE_HTTP: {
      setting: ["setHttpTrigger"],
      style: {
        nameBg: "bg-blue-trigger",
        nameIcon: "workflow_trigger_http"
      }
    }
  },
  UserVerify: {
    setting: ["userVerify"],
    style: {
      nameBg: "bg-red",
      nameIcon: "workflow_verify"
    }
  },
  ServiceUpdateSheet: {
    setting: ["updateFields"],
    style: {
      nameBg: "bg-yellow",
      nameIcon: "workflow_update"
    }
  },
  ServiceInsertSheet: {
    setting: ["insertSheetData"],
    style: {
      nameBg: "bg-yellow",
      nameIcon: "workflow_create"
    }
  },
  ServiceDeleteSheet: {
    setting: ["selectVar"],
    style: {
      nameBg: "bg-yellow",
      nameIcon: "workflow_delete"
    }
  },
  ServiceNotify: {
    web: {
      setting: ["setPeople", "inputTextarea", "notifyMethod", "jumpSetting"],
      style: {
        nameBg: "bg-red",
        nameIcon: "workflow_notify"
      }
    },
    ding: {
      setting: ["setPeople", "inputTextarea", "notifyMethod", "jumpSetting"],
      style: {
        nameBg: "bg-red",
        nameIcon: "workflow_notify"
      }
    },
    dingGroup: {
      setting: ["dingGroup"],
      style: {
        nameBg: "bg-red",
        nameIcon: "workflow_notify"
      }
    },
    phone: {
      setting: ["phone"],
      style: {
        nameBg: "bg-red",
        nameIcon: "workflow_notify"
      }
    },
    emailFile: {
      setting: ["email"],
      style: {
        nameBg: "bg-red",
        nameIcon: "workflow_notify"
      }
    }
  },
  ServiceSearchMulti: {
    setting: ["setSearch"],
    style: {
      nameBg: "bg-blue",
      nameIcon: "workflow_search"
    }
  },
  ServiceGetUser: {
    setting: ["setSearchUser"],
    style: {
      nameBg: "bg-blue",
      nameIcon: "workflow_search-people"
    }
  },
  ServicePdf: {
    setting: ["setPdf"],
    style: {
      nameBg: "bg-blue",
      nameIcon: "workflow_pdf"
    }
  },
  ServiceNumCompute: {
    setting: ["setNumCompute"],
    style: {
      nameBg: "bg-blue",
      nameIcon: "workflow_compute"
    }
  },
  ServiceDateCompute: {
    setting: ["setDateCompute"],
    style: {
      nameBg: "bg-blue",
      nameIcon: "workflow_compute"
    }
  },
  ServiceSheetCompute: {
    setting: ["setSheetCompute"],
    style: {
      nameBg: "bg-blue",
      nameIcon: "workflow_compute"
    }
  },
  ServiceHttp: {
    setting: ["setHttpRequest"],
    style: {
      nameBg: "bg-violet",
      nameIcon: "workflow_http"
    }
  },
  ServiceScript: {
    setting: ["setScript"],
    style: {
      nameBg: "bg-violet",
      nameIcon: "workflow_script"
    }
  },
  SubProcessRes: {
    setting: ["setSubProcessRes"],
    style: {
      nameBg: "bg-violet",
      nameIcon: "workflow_sub-process-res"
    }
  },
  TimerDelay: {
    setting: ["delayStr"],
    style: {
      nameBg: "bg-blue",
      nameIcon: "workflow_delay"
    }
  },
  SubProcess: {
    setting: ["setSubProcess"],
    style: {
      nameBg: "bg-blue",
      nameIcon: "workflow_sub-process"
    }
  },
  ServiceValidate: {
    setting: ["setServiceValidate"],
    style: {
      nameBg: "bg-blue",
      nameIcon: "workflow_validate"
    }
  },
  ServiceLock: {
    setting: ["selectTarget", "lockData"],
    style: {
      nameBg: "bg-yellow",
      nameIcon: "workflow_lock"
    }
  },
  ServiceSetPart: {
    setting: ["selectTarget", "selectPeople", "participants"],
    style: {
      nameBg: "bg-yellow",
      nameIcon: "workflow_participant"
    }
  },
  ServiceDataSync: {
    setting: ["selectRule"],
    style: {
      nameBg: "bg-yellow",
      nameIcon: "workflow_data-sync"
    }
  },
  UserSeal: {
    setting: ["setSeal"],
    style: {
      nameBg: "bg-green",
      nameIcon: "workflow_seal"
    }
  }
}

const taskFlowSettingMap = {
  UserVerify: {
    setting: ["userVerify"],
    style: {
      nameBg: "bg-red",
      nameIcon: "workflow_verify"
    }
  }
}

// 获取打开节点设置drawer的setting
export function getSettings(workFlow, workFlowType) {
  if (workFlow.type == "workFlowStart") return settingMap[workFlow.type][workFlow.trigger.type]
  if (workFlow.type == "ServiceNotify") return settingMap[workFlow.type][workFlow.data.type[0]]
  if (workFlowType == "task") return taskFlowSettingMap[workFlow.type]
  return settingMap[workFlow.type]
}

// 获取分支节点的条件比较方式
export function getCompareMethods({ type, from } = {}) {
  let compareMethods, compareType
  switch (type) {
    // 数字
    case "money":
    case "number":
    case "rate":
    case "calc":
    case "gather":
    case "progress": {
      compareMethods = ["大于", "大于等于", "小于", "小于等于", "等于", "不等于"]
      compareType = "Number"
      break
    }

    case "time":
    case "date": {
      compareMethods = [
        "在期间",
        "前...天内",
        "后...天内",
        "大于",
        "大于等于",
        "小于",
        "小于等于",
        "等于",
        "不等于"
      ]
      compareType = "Number"
      break
    }

    // 字符串
    case "sn":
    case "text":
    case "card":
    case "mail":
    case "telephone":
    case "money_cn":
    case "rich":
    case "url": {
      compareMethods = ["是", "不是", "包含", "不包含", "开头是", "开头不是", "结尾是", "结尾不是"]
      compareType = "String"
      break
    }
    case "address": {
      compareMethods = ["是", "不是", "包含", "不包含"]
      compareType = "String"
      break
    }

    // 选择
    case "radio": // 历史遗留控件,compareType应当是text,但是和Option很像,就放在一起了
    case "select": // 历史遗留控件,compareType应当是text,但是和Option很像,就放在一起了
    case "company":
    case "option":
    case "ref": {
      compareMethods = ["包含", "不包含"]
      compareType = "Select"
      break
    }
    case "area":
      compareMethods = ["包含", "不包含", "包含(模糊)", "在...中"]
      compareType = "Select"
      break
    case "department":
      if (from === "sheet_frontend") {
        compareMethods = ["包含", "不包含", "属于", "不属于", "是本部门", "属于本部门", "含本部门"]
      } else {
        compareMethods = ["包含", "不包含", "属于", "不属于"]
      }
      compareType = "Select"
      break
    case "staff": {
      if (from === "sheet_frontend") {
        compareMethods = ["包含", "不包含", "是上级", "是下属", "本人及下属", "是本人", "不是本人"]
      } else {
        compareMethods = ["包含", "不包含"]
      }
      compareType = "Select"
      break
    }
    case "check":
    case "bool":
    case "boolean":
    case "verify": {
      if (["workflow_search", "workflow_gateway"].includes(from)) {
        compareMethods = ["真", "假", "是"]
      } else {
        compareMethods = ["真", "假"]
      }
      compareType = "Number"
      break
    }

    default:
      compareMethods = []
      compareType = null
  }

  if (type != "verify") compareMethods = compareMethods.concat(["为空", "不为空"])
  else {
    if (from === "workflow_gateway") compareMethods = compareMethods.concat(["为空"])
  }

  return {
    compareMethods,
    compareType
  }
}

// 获取流程节点的设置信息并校验（用于post）
export function getFlowNodeData(allData, flowNodeData, workFlowData, settings) {
  let outputData = Object.assign({}, flowNodeData)
  if (
    ["ServiceSheetCompute", "ServiceDateCompute", "ServiceNumCompute", "ServiceHttp"].includes(
      flowNodeData.type
    )
  )
    return outputData
  !outputData.extra && (outputData.extra = {})
  for (let item of settings) {
    switch (item) {
      case "selectSheet":
      case "selectAvailableSheet": {
        if (flowNodeData.type == "workFlowStart") {
          outputData.trigger.sheetId = allData.selectedSheet
        }
        break
      }
      case "trigger": {
        outputData.trigger.operateType = allData.operateType
        if (["C", "U", "CU"].includes(allData.operateType)) {
          outputData.trigger.fields = allData.selectedFields
        }
        break
      }
      case "triggerCondition": {
        outputData.trigger.filters = allData.filters
        break
      }
      case "selectPerson": {
        if (flowNodeData.type == "UserVerify") {
          if (allData.verifyOriginator.length <= 0) throw "请选择审批发起人"
          outputData.data.originatorUserId = allData.verifyOriginator[0].value
          outputData.extra.verifyOriginator = allData.verifyOriginator
        }
        break
      }
      case "selectPeople": {
        if (["UserVerify", "UserFillSheet"].includes(flowNodeData.type)) {
          if (allData.selectPeopleBy == "people") {
            outputData.data.candidateUsers = allData.selectedPeople.map(i => i.value)
            outputData.data.userType = allData.staffStructure.value
              ? allData.staffStructure.value
              : "user"
            outputData.extra.selectedPeople = allData.selectedPeople
          } else if (allData.selectPeopleBy == "role") {
            outputData.data.candidateUsers = [allData.selectedRole]
            outputData.data.userType = "role"
          }
        } else if (flowNodeData.type == "ServiceNotify") {
          if (allData.selectPeopleBy == "people") {
            outputData.data.targets = allData.selectedPeople.map(i => i.value)
            outputData.data.userType = allData.staffStructure.value
              ? allData.staffStructure.value
              : "user"
            outputData.extra.selectedPeople = allData.selectedPeople
          } else if (allData.selectPeopleBy == "role") {
            outputData.data.targets = [allData.selectedRole]
            outputData.data.userType = "role"
          }
        } else if (flowNodeData.type == "ServiceSetPart") {
          outputData.data.participants = allData.selectedPeople.map(i => i.value)
          outputData.extra.selectedPeople = allData.selectedPeople
        }
        break
      }
      case "inputTextarea": {
        // 检查审批、通知、查找内容是否填写
        if (!allData.richTextObj.text) {
          if (flowNodeData.type == "ServiceNotify") throw "请填写通知内容"
          else if (flowNodeData.type == "ServiceSearch") throw "请填写查找内容"
        }
        if (flowNodeData.type == "ServiceNotify") {
          if (!outputData.data.baseMessage) outputData.data.baseMessage = {}
          outputData.data.baseMessage.content = allData.richTextObj.text
        } else if (flowNodeData.type == "ServiceSearch") {
          outputData.data.value = allData.richTextObj.text
        }
        outputData.extra.textarea = allData.richTextObj.arr
        break
      }
      case "selectTarget": {
        if (["UserFillSheet", "ServiceUpdateSheet"].includes(flowNodeData.type)) {
          outputData.data.sheetDataId = allData.selectedTarget
          outputData.data.sheetId = allData.sheetId
        } else if (["ServiceLock", "ServiceSetPart"].includes(flowNodeData.type)) {
          outputData.data.dataId = allData.selectedTarget
          outputData.data.sheetId = allData.sheetId
        }
        break
      }
      case "selectVar": {
        outputData.data.var = allData.selectedVar
        outputData.data.sheetId = allData.sheetId
        break
      }
      case "selectFillFields": {
        outputData.data.fields = allData.selectedFillFields
        break
      }
      case "selectField": {
        outputData.data.controlId = allData.selectedField
        break
      }
      case "selectExecuteTime": {
        allData.executeTime.sheetId = allData.selectedSheet
        outputData.trigger = Object.assign(outputData.trigger, allData.executeTime)
        break
      }
      case "updateFields": {
        outputData.data.updateInfo = {}
        allData.updateFields.forEach(i => {
          outputData.data.updateInfo[i.key] = {
            type: i.type,
            value: i.value
          }
        })
        outputData.data.sheetId = outputData.extra.sheetId
        break
      }
      case "notifyMethod": {
        outputData.data.type = allData.selNotifyMethods
        let notifyMethodMap = notifyMethods.reduce((acc, cur) => {
          acc[cur.value] = cur.label
          return acc
        }, {})
        let labels = allData.selNotifyMethods.map(method => notifyMethodMap[method].substring(0, 2))
        outputData.extra.notifyMethod = "通知（" + labels.join("，") + "）"
        break
      }
      case "jumpSetting": {
        outputData.data.baseMessage.type = "COMMON"
        if (allData.jumpChecked && workFlowData.type == "task") {
          outputData.extra.dataId = "trigger_task.getId()"
          outputData.data.baseMessage.extra = {
            dataId: "trigger_task.getId()",
            appId: workFlowData.appId
          }
        } else if (allData.jumpChecked && allData.selNotifyMethods.toString() != "ding") {
          bfs({
            arr: allData.jumpMethods,
            childFuc: varGroup => varGroup.children,
            cbk: varGroup => {
              allData.jumpMethods.push(varGroup)
            }
          })
          let content = allData.jumpMethods
            .flatMap(value => [value.options])
            .flat()
            .find(item => item.value === allData.selJumpMethods)
          outputData.extra.dataId = content.value
          // 跳转工作表
          if (content.type == "data") {
            outputData.data.baseMessage.extra = {
              dataId: content.value,
              sheetId: content.sheetId,
              type: content.type
            }
            //  跳转看板
          } else {
            outputData.data.baseMessage.extra = {
              boardId: content.value,
              appId: content.appId,
              type: content.type
            }
          }
        } else {
          delete outputData.extra.dataId
          delete outputData.data.baseMessage.extra
        }
        break
      }
      case "inputCornstr": {
        outputData.trigger.cronStr = allData.cronStr
        break
      }
      case "delayStr": {
        outputData.data.expression = allData.delayStr
        break
      }
      case "lockData": {
        outputData.data.lock = allData.lock
        break
      }
      case "participants": {
        outputData.data.add = allData.isAdd
        break
      }
      case "selectRule": {
        outputData.data.isMaster = flowNodeData.data.isMaster
        outputData.data.ruleId = allData.selectedRuleId
        outputData.data.dataExpression = allData.selectedSheetData
        outputData.data.targets = allData.selectedSyncTarget
        break
      }
      case "dingGroup": {
        outputData.extra.notifyMethod = "群通知（钉钉）"
        outputData.data.dingGroupId = allData.dingGroupData.selGroupMethods
        outputData.data.baseMessage.content = allData.dingGroupData.richTextObj.text
        outputData.extra.textarea = allData.dingGroupData.richTextObj.arr
        break
      }
      case "email": {
        outputData.data.type = ["emailFile"]
        outputData.extra.notifyMethod = "邮件通知"
        outputData.data.mailMessage = {
          content: allData.emailData.contentObj.text,
          subject: allData.emailData.subjectObj.text,
          fileList: allData.emailData.fileList,
          emailDefs: [].concat(allData.emailData.emailDefs || []),
          emails: allData.emailData.emails
        }
        outputData.extra.emailDefsExtra = [].concat(allData.emailData.emailDefsExtra || [])
        outputData.extra.emailContent = allData.emailData.contentObj.arr
        outputData.extra.emailSubject = allData.emailData.subjectObj.arr
        break
      }
      case "parallel": {
        outputData.trigger.parallelSetting = {
          limitType: allData.limitType,
          limitCids: allData.limitCids,
          waitSecond: allData.waitSecond
        }
        break
      }
    }
  }
  return outputData
}

// 更新流程中的节点信息（包括工作流的触发方式）
export function updateFlowNode(requestData, nodeInfo) {
  if (nodeInfo.type == "workFlowStart") {
    // eslint-disable-next-line no-unused-vars
    let { id, type, ...temp } = nodeInfo
    requestData = Object.assign(requestData, temp)
  } else {
    let dmProcess = requestData.dmProcess.items
    for (let item of dmProcess) {
      if (item.id == nodeInfo.id) {
        item = Object.assign(item, nodeInfo)
        break
      }
    }
  }
  return requestData
}

// 节点对象的默认信息
const nodeMap = {
  Gateway: [
    {
      id: "gateway",
      name: "分支",
      nexts: [],
      type: "Gateway",
      extra: { isGray: true, description: [] },
      data: {
        nextFilters: [[], []]
      }
    },
    {
      id: "gateway",
      name: "分支",
      nexts: [],
      type: "Gateway",
      extra: null,
      data: {
        nextFilters: []
      }
    }
  ],
  UserFillSheet: {
    id: "userFillSheet",
    name: "填写",
    nexts: [],
    type: "UserFillSheet",
    extra: { isGray: true },
    data: {
      candidateUsers: [],
      userType: "user",
      type: "fill",
      sheetDataId: "",
      sheetId: "",
      fields: []
    }
  },
  UserVerify: {
    id: "userVerify",
    name: "审批",
    nexts: [],
    type: "UserVerify",
    extra: { isGray: true },
    data: {
      originatorUserId: null,
      dataVar: "",
      sheetId: "",
      content: "",
      or: true,
      dingProcessId: null,
      dingFlag: false,
      verifyItems: [],
      verifyContents: [],
      canCancel: true,
      canChangeCandidate: true,
      candidateUsers: [],
      userType: "user",
      type: "verify",
      acceptFillCids: [
        {
          cid: "verifyComments",
          type: "W",
          subList: []
        },
        {
          cid: "verifySign",
          type: "W",
          subList: []
        }
      ],
      rejectFillCids: [
        {
          cid: "verifyComments",
          type: "H",
          subList: []
        },
        {
          cid: "verifySign",
          type: "R",
          subList: []
        }
      ]
    }
  },
  ServiceSearch: {
    id: "serviceSearch",
    name: "查找",
    nexts: [],
    type: "ServiceSearch",
    extra: { isGray: true },
    data: {
      sheetId: "",
      controlId: "",
      value: ""
    }
  },
  ServiceUpdateSheet: {
    id: "serviceUpdateSheet",
    name: "更新记录",
    nexts: [],
    type: "ServiceUpdateSheet",
    extra: { valueMap: {}, isGray: true },
    data: {
      sheetDataId: "",
      varKey: "UpdateData",
      updateInfo: {},
      map: {}
    }
  },
  ServiceInsertSheet: {
    id: "serviceInsertSheet",
    name: "新增记录",
    nexts: [],
    type: "ServiceInsertSheet",
    extra: { valueMap: {}, isGray: true },
    data: { sheetId: "", map: {} }
  },
  ServiceDeleteSheet: {
    id: "serviceDeleteSheet",
    name: "删除记录",
    nexts: [],
    type: "ServiceDeleteSheet",
    extra: { isGray: true },
    data: {
      sheetId: "",
      var: ""
    }
  },
  ServiceNotify: {
    id: "serviceNotify",
    name: "通知",
    nexts: [],
    type: "ServiceNotify",
    extra: { isGray: true },
    data: {
      targets: [],
      candidates: [],
      userType: "user",
      content: "",
      baseMessage: {},
      phoneMessage: {
        params: {},
        telephones: [],
        templateCode: "",
        sign: ""
      },
      mailMessage: {
        emails: [],
        subject: "",
        content: "",
        fileList: [],
        emailDefs: []
      }
    }
  },
  ServiceSearchMulti: {
    id: "ServiceSearchMulti",
    name: "查找",
    nexts: [],
    type: "ServiceSearchMulti",
    extra: { isGray: true },
    data: {
      sheetId: "",
      viewId: "",
      size: null,
      sizePercent: null,
      condition: [],
      fieldInfos: [],
      sorts: []
    }
  },
  ServiceGetUser: {
    id: "ServiceGetUser",
    name: "查找用户",
    nexts: [],
    type: "ServiceGetUser",
    extra: { isGray: true },
    data: {
      filters: []
    }
  },
  ServicePdf: {
    id: "ServicePdf",
    name: "获取打印文件",
    nexts: [],
    type: "ServicePdf",
    extra: { isGray: true },
    data: {
      templateId: "",
      dataId: ""
    }
  },
  ServiceNumCompute: {
    id: "ServiceNumCompute",
    name: "数值运算",
    nexts: [],
    type: "ServiceNumCompute",
    extra: { isGray: true },
    data: {
      calcType: "NUM",
      var1: "",
      var2: "",
      expression: "",
      unit: "",
      calcUnit: "",
      decimal: 0
    }
  },
  ServiceDateCompute: {
    id: "ServiceDateCompute",
    name: "日期运算",
    nexts: [],
    type: "ServiceDateCompute",
    extra: {
      inFlow: false,
      label: "",
      isGray: true
    },
    data: {
      type: "",
      start: "",
      format: "",
      value: { years: 0, months: 0, days: 0, hours: 0, minutes: 0, seconds: 0 }
    }
  },
  ServiceSheetCompute: {
    id: "ServiceSheetCompute",
    name: "批量数据运算",
    nexts: [],
    type: "ServiceSheetCompute",
    extra: { isGray: true },
    data: {
      type: "",
      varName: "",
      method: "",
      cid: ""
    }
  },
  ServiceHttp: {
    id: "serviceHttp",
    name: "网络请求",
    nexts: [],
    type: "ServiceHttp",
    data: {
      url: "",
      httpMethod: "GET",
      requestHeaders: null,
      requestBody: null
    },
    extra: { isGray: true }
  },
  ServiceScript: {
    id: "serviceScript",
    name: "代码块",
    nexts: [],
    type: "ServiceScript",
    data: {
      input: null,
      scriptStr: "",
      output: null
    },
    extra: { isGray: true }
  },
  SubProcessRes: {
    id: "subProcessRes",
    name: "子流程出参",
    nexts: [],
    type: "SubProcessRes",
    data: {
      expresion: ""
    },
    extra: { isGray: true }
  },
  TimerDelay: {
    id: "timerDelay",
    name: "延时",
    nexts: [],
    type: "TimerDelay",
    data: {
      expression: ""
    },
    extra: { isGray: true }
  },
  SubProcess: {
    id: "subProcess",
    name: "子流程",
    nexts: [],
    type: "SubProcess",
    data: {
      subProcessId: "",
      sequential: true,
      single: false,
      async: false,
      var: "",
      extraInput: [],
      output: null
    },
    extra: { isGray: true }
  },
  ServiceValidate: {
    id: "serviceValidate",
    name: "校验",
    nexts: [],
    type: "ServiceValidate",
    data: {
      items: [],
      sendMsg: false
    },
    extra: { isGray: true }
  },
  ServiceLock: {
    id: "serviceLock",
    name: "锁定/解锁记录",
    nexts: [],
    type: "ServiceLock",
    data: {
      sheetId: "",
      dataId: "",
      lock: true
    },
    extra: { isGray: true }
  },
  ServiceSetPart: {
    id: "serviceSetPart",
    name: "设置参与人",
    nexts: [],
    type: "ServiceSetPart",
    data: {
      sheetId: "",
      dataId: "",
      participants: [],
      add: true
    },
    extra: { isGray: true }
  },
  ServiceDataSync: {
    id: "serviceDataSync",
    name: "数据同步",
    nexts: [],
    type: "ServiceDataSync",
    extra: { isGray: true },
    data: {
      ruleId: "",
      dataExpression: ""
    }
  },
  UserSeal: {
    id: "UserSeal",
    name: "电子签章",
    nexts: [],
    type: "UserSeal",
    extra: {
      valueMap: {
        signParams: [],
        startUserInfo: {}
      },
      isGray: true
    },
    data: {
      type: "e签宝",
      startUserInfo: {},
      signParams: [],
      attachmentId: ""
    }
  }
}

// 生成节点id
function getNodeId(nodeId, process) {
  let id = nodeId + "_" + randomString(5)
  let repeated = process.find(i => i.id == id)
  while (repeated) {
    id = nodeId + "_" + randomString(5)
    repeated = process.find(i => i.id == id)
  }
  return id
}

// 获取插入节点的上一节点的next
function getPreNodeNext(preNode, branchIndex, process) {
  if (preNode.type == "workFlowStart") return process[0] ? process[0].id : undefined
  if (preNode.type == "Gateway" && branchIndex !== null) return preNode.nexts[branchIndex]
  else return preNode.nexts[0]
}

function generateNewNode(nodeType, process, dataType) {
  let newNodes = _.cloneDeep(nodeMap[nodeType])
  if (!_.isArray(newNodes)) {
    newNodes = [newNodes]
  }
  newNodes[0].id = getNodeId(newNodes[0].id, process)
  if (nodeType == "Gateway") {
    newNodes[1].id = newNodes[0].id + "_close"
  }

  if (nodeType == "ServiceNotify") {
    newNodes[0].data.type = [dataType]
    if (dataType == "dingGroup") newNodes[0].name = "群通知"
    else if (dataType === "phone") newNodes[0].name = "短信通知"
    else if (dataType === "email") newNodes[0].name = "邮件通知"
  }
  return newNodes
}

/**
 * 查找分支结束节点
 * @param processItems
 * @param startNodeId
 * @returns {null|*} null: 未找到节点
 */
export function findBranchEndNode(processItems, startNodeId) {
  let nodeMap = _.keyBy(processItems, "id")
  let curNode = nodeMap[startNodeId]
  // 如果初始节点就是网关结束节点或者不存在,则代表此分支为空
  if (!curNode || _.endsWith(curNode.id, "_close")) return null
  while (curNode) {
    // 遇到网关开始节点,则直接跳到结束节点
    if (curNode.type == "Gateway" && !_.endsWith(curNode.id, "_close")) {
      curNode = nodeMap[curNode.id + "_close"]
      continue
    }
    // 如果当前节点没有下一个节点,或者当前节点指向网关结束节点,则代表此分支结束
    if (_.isEmpty(curNode.nexts) || _.endsWith(curNode.nexts[0], "_close")) return curNode
    curNode = nodeMap[curNode.nexts[0]]
  }
  return null
}

/**
 * 向流程中插入新的节点
 * @param workflowServer 服务端工作流结构
 * @param preNode 在哪个工作流节点后添加新节点
 * @param insertNodeType 新节点类型
 * @param branchIndex 添加到分支节点的第几个分支(为空则表示添加到分支节点的结束节点之后)
 * @param moveFlag 是否移动下方所有节点到分支的左侧分支中
 * @returns {*}
 */
export function insertFlowNode({
  requestData: workflowServer,
  preNode,
  insertNodeType,
  branchIndex,
  moveFlag,
  dataType
}) {
  let process = workflowServer.dmProcess.items
  let newNodes = generateNewNode(insertNodeType, process, dataType)
  // branchIndex 为 null 代表是在分支节点的闭合节点后插入
  if (preNode.type == "Gateway" && branchIndex === null) {
    preNode = getNodeInProcess(preNode.id + "_close", process)
  }
  let preNodeIndex = process.findIndex(i => i.id == preNode.id)

  // 设置新节点的nexts
  let preNodeNext = getPreNodeNext(preNode, branchIndex, process)
  if (insertNodeType == "Gateway") {
    if (!moveFlag) {
      newNodes[0].nexts = [newNodes[1].id, newNodes[1].id]
      newNodes[1].nexts = preNodeNext ? [preNodeNext] : []
    } else {
      newNodes[0].nexts = [preNodeNext || newNodes[1].id, newNodes[1].id]
      let endNode = findBranchEndNode(process, preNodeNext)
      newNodes[1].nexts = endNode.nexts
      endNode.nexts = [newNodes[1].id]
    }
  } else {
    newNodes[0].nexts = preNodeNext ? [preNodeNext] : []
  }

  // 设置preNode的nexts
  if (preNode.type !== "workFlowStart") {
    if (preNode.type == "Gateway" && branchIndex !== null) {
      process[preNodeIndex].nexts[branchIndex] = newNodes[0].id
    } else process[preNodeIndex].nexts[0] = newNodes[0].id
  }

  // 向 process 插入新的节点
  process.splice(preNodeIndex + 1, 0, ...newNodes)
  return workflowServer
}

// 设置删除节点的上一节点信息
function setPreNode(nodeInfo, process) {
  let preNode = process.find(i => i.nexts.includes(nodeInfo.id))
  if (!preNode) return
  let closeNodeInfo
  if (nodeInfo.type == "Gateway") {
    let index = getNodeIndex(nodeInfo.id + "_close", process)
    closeNodeInfo = process[index]
  }
  let preNodeNext = nodeInfo.type == "Gateway" ? closeNodeInfo.nexts[0] : nodeInfo.nexts[0]
  if (preNode.type == "Gateway" && !preNode.id.endsWith("_close")) {
    let branchIndex = preNode.nexts.indexOf(nodeInfo.id)
    preNode.nexts[branchIndex] = preNodeNext
  } else preNode.nexts = preNodeNext ? [preNodeNext] : []
}

// 通过节点id获取节点在流程中的索引
function getNodeIndex(nodeId, process) {
  return process.findIndex(i => i.id == nodeId)
}

// 删除分支节点及其范围内的所有节点
function deleteGateWay(nodeInfo, process, branchIndex) {
  let gatewayNode = process.find(node => node.id === nodeInfo.id)
  let deleteNode = gatewayNode.nexts.length <= 2 // 是否删除整个分支节点
  let closeId = nodeInfo.id + "_close"
  let queue = deleteNode ? nodeInfo.nexts : [nodeInfo.nexts[branchIndex]]
  let needDeleteIds = []
  while (queue.length) {
    let nodeId = queue.shift()
    if (nodeId === closeId) continue // 终止
    needDeleteIds.push(nodeId)
    let node = process.find(t => t.id === nodeId)
    if (node) queue.push(...node.nexts)
  }
  if (deleteNode) {
    setPreNode(nodeInfo, process)
    needDeleteIds.push(nodeInfo.id, closeId)
  } else {
    gatewayNode.nexts.splice(branchIndex, 1)
    gatewayNode.data.nextFilters.splice(branchIndex, 1)
    gatewayNode.extra.description.splice(branchIndex, 1)
  }
  _.remove(process, node => needDeleteIds.includes(node.id))
}

// 从流程中删除节点
export function deleteFlowNode(requestData, nodeInfo, branchIndex) {
  let process = requestData.dmProcess.items
  if (nodeInfo.type == "Gateway") {
    deleteGateWay(nodeInfo, process, branchIndex)
  } else {
    let nodeIndex = getNodeIndex(nodeInfo.id, process)
    if (nodeIndex == 0) process.shift()
    else {
      setPreNode(nodeInfo, process)
      process.splice(nodeIndex, 1)
    }
  }
  return requestData
}

// 获取通知方式
export const notifyMethods = [
  {
    label: "站内通知",
    value: "web"
  },
  {
    label: "钉钉通知",
    value: "ding"
  }
]

export function comType2ValType(compareType, controlType) {
  let valType = ""
  switch (compareType) {
    case "String": {
      valType = "multipleSelect"
      break
    }

    case "Number": {
      switch (controlType) {
        case "time":
          valType = "time"
          break
        case "date":
          valType = "date"
          break
        default:
          valType = "number"
      }
      break
    }

    case "Select": {
      valType = "select"
      break
    }

    default:
      valType = "number"
  }
  return valType
}

export function filterTreeVarGroup({
  varGroup = [],
  filterFunc = option => true, // 是否保留此option
  mapFunc = option => option
}) {
  return (varGroup || [])
    .map(v => {
      let { label, options, children } = v
      options = options?.filter(option => filterFunc(option)).map(option => mapFunc(option))
      children = filterTreeVarGroup({ varGroup: children, filterFunc, mapFunc })
      if (!options?.length && !children?.length) return null
      return { label, options, children }
    })
    .filter(v => v)
}

export function transWorkflowVarGroup2TreeVarGroup(workflowVarGroup, controlTypeMap) {
  if (_.isEmpty(workflowVarGroup) || _.isEmpty(controlTypeMap)) return []
  let res = _.cloneDeep(workflowVarGroup)
  bfs({
    cloneDeep: false,
    arr: res,
    childFuc: varGroup => varGroup.groups || varGroup.children,
    cbk: varGroup => {
      let target = {
        label: varGroup.name,
        children: varGroup.groups,
        options: varGroup.vars
          .filter(v => v.control?._type !== "remark")
          .map(v => {
            return {
              label: `[${varGroup.name}] ${v.name}`,
              customLabel: `[${controlTypeMap[v.control._type]?.name}] ${v.name}`,
              value: v.expresion,
              strValue: v.expresionStr,
              control: v.control,
              isArray: v.array
            }
          })
      }
      Object.keys(varGroup).forEach(key => delete varGroup[key])
      Object.assign(varGroup, target)
    }
  })
  return res
}

/**
 * 用于兼容之前已经设置好的工作流节点属性
 * (对于后续增加的新节点无需使用)
 * @param expr
 * @returns {string|*}
 */
export function transOldExpr(expr) {
  if (!_.isString(expr) || expr.startsWith("dealObj") || isValidObjectId(expr)) return expr
  return `dealObj({${expr}})`
}
